<script lang="ts" setup />

<template>
  <ContactFormWrapper submit-button-color="#103d5c" class="rounded-lg" />
</template>
